import styled from "styled-components";

export const Cont = styled.div`
   
  

   #loading, #loading2, #aguarde, #btn-envia-formulario-loading{
    display: none
   }

   input[type="file"] {
    width: 90%;
}
   
   .small, small {
        font-size: 12px;
        font-weight: 400;
        display: block;
    }
    .uk-list>*>ul, .uk-list>:nth-child(n+2){
        margin-top: 0!important;
   }
   
  

        @media only screen and  (max-width: 1366px) {

  
        }

        @media only screen and  (max-width: 1024px) {


        }
        @media only screen and  (max-width: 801px) {
            

        }

        @media only screen and  (max-width: 480px) {

        
        }

        @media only screen and  (max-width: 480px) {
        
        }


`;

export const HomeCss = styled.div`

 



`; 